// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Alsd","option":"styles_option__34ogy","selected":"styles_selected__2w1Yg"};